import JSX from "../../helpers/react.js";
import {CommentsBlock} from "./CommentsBlock.js";

$(function (){
    const el = document.getElementById('comments-tab');
    if(el){
        el.innerText = '';
        el!.appendChild(<CommentsBlock />);
    }
})